import { InternalService } from "@/generated";

export async function translateIntroMessage({
  groupId,
  text,
  targetLanguage,
  signal,
}: {
  groupId: string;
  text: string;
  targetLanguage: string;
  signal?: AbortSignal;
}): Promise<string> {
  const { data } = await InternalService.translateText({
    path: { group_id: groupId },
    body: { text, target_language: targetLanguage },
    signal,
  });
  return data.text.trim();
}
